import React from 'react';
import styles from './InfoSection.module.less';
import { InformationSmIcon } from '@paypalcorp/pp-react';
import RenderEcmRichText from '../../../components/Text/RenderEcmRichText';

const InfoSection = ({ ecmContent: { content } }) => {
  return (
    <div className={styles.wrapper}>
      <InformationSmIcon size="sm" className={styles.icon} />
      <RenderEcmRichText className={styles.content} content={content} />
    </div>
  );
};

export default InfoSection;
